﻿import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_services';
import { Router } from '@angular/router';
import { Producto, Lista } from 'src/app/_models';


@Component({ templateUrl: 'crear.component.html' })
export class CrearComponent implements OnInit {

    productos: Array<Producto>;
    crearForm: FormGroup;
    loading = false;
    submitted = false;
    // mercadoPago: boolean = false;
    // monetizada: boolean = false;
    mail: boolean = true;
    precioLista: number = 0;

    // datePattern = "^(0[1-9]|[12][0-9]|3[01])\/((0[1-9])|(1[0-2]))\/(\\d{4}) (([01][0-9]|[012][0-3]):([0-5][0-9]))$"; 
    datePattern = "^(\\d{4})-((0[1-9])|(1[0-2]))-(0[1-9]|[12][0-9]|3[01])$";




    constructor(
        private formBuilder: FormBuilder,
        private restService: RestService,
        private alertService: AlertService,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.restService.getAll('/rest-api/public/parametro/').subscribe
            (response => {
                response.forEach(data => {
                    if (data.clave === 'lista.nueva.mostrar.productos') {
                        if (data.valor.toString().toUpperCase() === 'TRUE')
                            this.loadAll();
                    } else if (data.clave === 'precio.lista') {
                        this.precioLista = parseFloat(data.valor.toString());
                    }

                });
                this.crearForm = this.formBuilder.group({
                    name: ['', Validators.required],
                    codigo: ['', Validators.required],
                    fecha: ['', [Validators.required, Validators.pattern(this.datePattern)]],
                });


            });
    }



    private loadAll() {
        this.restService.getAll('/rest-api/public/producto').subscribe(data => {
            this.productos = data;
        });
    }

    // private esMonetizada(): boolean {
    //     return this.mercadoPago && this.monetizada;
    // }


    // convenience getter for easy access to form fields
    get f() { return this.crearForm.controls; }

    onSubmit() {
        this.submitted = true;
        if (this.crearForm.invalid) {
            return;
        }

        this.loading = true;
        const lista: Lista = new Lista();

        lista.nombre = this.f.name.value;
        lista.codigo = this.f.codigo.value;
        //lista.lugar = this.f.lugar.value;
        lista.mail = this.mail;
        // lista.monetizada = this.monetizada;
        // if (this.mercadoPago)
        //     lista.userMercadoPago = this.f.userMercadoPago.value;
        lista.productos = this.productos;
        if (this.f.fecha.value) {
            console.log(this.f.fecha.value);
            lista.fecha = new Date(this.f.fecha.value.replace("-", "/"));
            console.log(lista.fecha);
        }
        // this.restService.post('/rest-api/user/lista', lista)
        //     .subscribe(
        //         data => {
        //             if (data.status === 200) {
        //                 this.router.navigate(['/user/gracias/' + data.lista.id]);
        //             } else {
        //                 this.alertService.error('<h3>Error</h3>Ya existe una lista con ese nombre y c&oacute;digo', false);
        //                 this.submitted = false;
        //                 this.loading = false;
        //             }
        //         });
        this.submitted = false;
        this.loading = false;
    }



}
